import React from 'react';

const YearMenu = (props) => {
        return(
            <div>
                <select className="form-control" name={props.name} onChange={props.setYear}>
                    <option value="0">Year...</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                </select>
            </div>
        );
}

export default YearMenu;